export enum ExpressionEditor {
  DATAHEADER = 'Data',
  EXPRESSIONHEADER = 'Expression',
  RESULTHEADER = 'Result',
}
